import { useAangifte } from "components/aangifte/AangifteProvider";
import React, { FunctionComponent } from "react";
import { HelpForm } from "./HelpForm";
import { getLangetermijnsparenLimit } from "./langetermijnsparen";
import { TaxCodeHelpDialog } from "./TaxCodeHelpDialog";

export interface Props {
  code: string;
  onClose: () => void;
}

export const codesForKapitaalaflossingLangetermijnsparen = ["1358", "2358", "3358", "4358"];

export const HelpKapitaalaflossingLangetermijnsparen: FunctionComponent<Props> = ({ code, onClose }) => {
  const {
    dispatch,
    aangifte: { city },
  } = useAangifte();
  const handleSubmit = React.useCallback(
    (values) => {
      const { jaarLening, kapitaalaflossing, bedragLening } = values;
      const langetermijnsparenLimit = getLangetermijnsparenLimit(jaarLening, city!.gewest, code as string);
      const langetermijnsparen =
        (kapitaalaflossing * Math.min(langetermijnsparenLimit, bedragLening)) / bedragLening || 0;

      dispatch({ type: "UPDATE_RUBRIEK_VALUE", code, value: langetermijnsparen });

      onClose();
    },
    [city, code, dispatch, onClose]
  );

  return (
    <TaxCodeHelpDialog code={code} onClose={onClose} dialogForCodes={codesForKapitaalaflossingLangetermijnsparen}>
      <HelpForm fields={["kapitaalaflossing", "bedragLening", "jaarLening"]} onSubmit={handleSubmit} code={code} />
    </TaxCodeHelpDialog>
  );
};

HelpKapitaalaflossingLangetermijnsparen.displayName = "HelpKapitaalaflossingLangetermijnsparen";
